(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$(document).ready(function () {
  initializeMap();
  $(window).scroll(function () {
    if ($(document).scrollTop() > 50) {
      $(".fixed-top").css("background-color", "#DED9D1");
    } else {
      $(".fixed-top").css("background-color", "#E6E1D9");
    }
  });

  if (ismsie()) {
    new fullpage('#page', {
      licenseKey: '979511F6-A00A4658-B9FC877C-408B9528',
      autoScrolling: false,
      fitToSection: false,
      responsiveWidth: 1180,
      animateAnchor: false,
      css3: true
    });
  } else {
    new fullpage('#page', {
      licenseKey: '979511F6-A00A4658-B9FC877C-408B9528',
      autoScrolling: false,
      fitToSection: true,
      fitToSectionDelay: 100,
      responsiveWidth: 1180,
      animateAnchor: false,
      css3: true
    });
  } // to top right away


  if (window.location.hash) scroll(0, 0); // void some browsers issue

  setTimeout(function () {
    scroll(0, 0);
  }, 1); // any position

  $(function () {
    // your current click function
    $('.scroll').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top + 'px'
      }, 1000, 'swing');
    }); // *only* if we have anchor on the url

    if (window.location.hash) {
      // smooth scroll to the anchor id
      $('html, body').animate({
        scrollTop: $(window.location.hash).offset().top + 'px'
      }, 1000, 'swing');
    }
  });
  $('.menu-toggle').on('click', function () {
    $('.menu-toggle').toggleClass('active');
  });
  $('#clickme').click(function () {
    $('#menu').slideToggle('500', 'linear');
  });
  $('.phone-nav').click(function () {
    $('.num_tel').fadeToggle("slow", "linear");
  });
  $("#menu ul li a").on('click', function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function () {
        window.location.hash = hash;
      });
    }
  }); // close hamburger menu after click a

  $('#menu ul li a').on("click", function () {
    $('.menu-toggle').click();
  });
  $('.slider-1').slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 1,
    prevArrow: $('.nos_marques_nav_hidden .prev-1'),
    nextArrow: $('.nos_marques_nav_hidden .next-1'),
    responsive: [{
      breakpoint: 1120,
      // tablet breakpoint
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 480,
      // mobile breakpoint
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $('.slider-2').slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 1,
    prevArrow: $('.nos_marques_nav_hidden .prev-2'),
    nextArrow: $('.nos_marques_nav_hidden .next-2'),
    responsive: [{
      breakpoint: 1120,
      // tablet breakpoint
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 480,
      // mobile breakpoint
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  var isSlidingNext = false;
  var isSlidingPrev = false;
  $(document).on('click', '.nos_marques_nav .next-1', function () {
    if (!isSlidingNext) {
      isSlidingNext = true;
      $('.brands-1').animate({
        'margin-top': '-175px'
      }, 300, function () {
        $('.nos_marques_nav_hidden .next-1').trigger('click');
      });
      $('.slider-2').animate({
        'margin-top': '175px'
      }, 300);
      $('.brands-2').animate({
        'margin-top': '240px'
      }, 300, function () {
        $('.nos_marques_nav_hidden .next-2').trigger('click');
      });
    }
  });
  $(document).on('click', '.nos_marques_nav .prev-1', function () {
    if (!isSlidingPrev) {
      isSlidingPrev = true;
      $('.brands-1').animate({
        'margin-top': '-175px'
      }, 300, function () {
        $('.nos_marques_nav_hidden .prev-1').trigger('click');
      });
      $('.slider-2').animate({
        'margin-top': '175px'
      }, 300);
      $('.brands-2').animate({
        'margin-top': '240px'
      }, 300, function () {
        $('.nos_marques_nav_hidden .prev-2').trigger('click');
      });
    }
  });
  $('.slider-1').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $('.brands-1').animate({
      'margin-top': '35px'
    }, 300);
    $('.slider-2').animate({
      'margin-top': '-20px'
    }, 300, function () {
      isSlidingNext = false;
      isSlidingPrev = false;
    });
  });
  $('.slider-2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $('.brands-2').animate({
      'margin-top': '35px'
    }, 300);
    $('.slider-2').animate({
      'margin-top': '-20px'
    }, 300, function () {
      isSlidingNext = false;
      isSlidingPrev = false;
    });
  }); //Load more

  $(document).on('click', '.load_more_news', function () {
    var button = $(this);
    var data = {
      'action': 'loadmore',
      'query': custom_params.posts,
      'page': custom_params.current_page,
      'max_page': custom_params.max_page
    };
    $.ajax({
      url: custom_params.ajaxurl,
      data: data,
      type: 'POST',
      beforeSend: function beforeSend(xhr) {
        button.text('Chargement...');
      },
      success: function success(data) {
        if (data) {
          button.text('Voir plus d\'actualités').before(data);
          custom_params.current_page++;
          if (custom_params.current_page == custom_params.max_page) button.remove();
        } else {
          button.remove();
        }
      }
    });
  });
  onScroll();
  $(window).scroll(onScroll);
  onResize();
  $(window).resize(onResize);

  function initializeMap() {
    //Main map initialization
    var map = L.map('map', {
      attributionControl: false
    }).setView([49.592141, 6.116654], 17); //Create icon as marker

    var mapIcon = L.icon({
      iconUrl: custom_params.templateUrl + '/dist/images/mapIco.svg',
      iconSize: [41.6, 50],
      iconAnchor: [10, 50]
    }); //Add the icon we just created

    var marker = L.marker([49.592141, 6.116654], {
      icon: mapIcon
    }).addTo(map); //Add the tile style of the map

    L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
      attribution: ''
    }).addTo(map);
  }

  function onResize() {}

  function onScroll() {} // Add smooth scrolling to all links


  $(".scroll-down a").on('click', function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault(); // Store hash

      var hash = this.hash; // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area

      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function () {
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if

  });
});
$('.owl-carousel').owlCarousel({
  loop: true,
  margin: 10,
  stagePadding: 50,
  dots: false,
  nav: true,
  navText: ['<img src="https://batic.mikado.digital/wp-content/themes/baticdesign/dist/images/arrow_right.svg">', '<img src="https://batic.mikado.digital/wp-content/themes/baticdesign/dist/images/arrow_left.svg">'],
  responsive: {
    0: {
      items: 1
    },
    1025: {
      items: 2
    }
  }
});

function ismsie() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  var msie11 = !!window.MSInputMethodContext && !!document.documentMode;

  if (msie > 0 || msie11) {
    return true;
  }

  return false;
}

},{}]},{},[1]);
